__webpack_require__.p = "https://zoshineshop.oss-cn-beijing.aliyuncs.com/bixuan-h5/pro/20251218/";